import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { LOGO_URL } from "./brand";

const links = [
    { id: "capabilities", label: "できること" },
    { id: "works", label: "制作実績" },
    { id: "process", label: "開発の流れ" },
    { id: "about", label: "会社概要" },
];

export default function Header() {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 12);
        onScroll();
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const scrollTo = (id) => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        setOpen(false);
    };

    return (
        <header
            data-testid="site-header"
            className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
                scrolled
                    ? "backdrop-blur-xl bg-white/85 border-b border-[#E6EFD8]"
                    : "bg-transparent"
            }`}
        >
            <div className="max-w-7xl mx-auto px-5 sm:px-8 py-3 flex items-center justify-between">
                <a
                    href="#top"
                    data-testid="site-logo"
                    onClick={(e) => {
                        e.preventDefault();
                        window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    className="flex items-center group"
                >
                    <img
                        src={LOGO_URL}
                        alt="やさまる電電開発"
                        className="h-10 sm:h-11 w-auto group-hover:opacity-80 transition-opacity"
                        draggable={false}
                    />
                </a>

                <nav className="hidden md:flex items-center gap-1">
                    {links.map((l) => (
                        <button
                            key={l.id}
                            data-testid={`nav-link-${l.id}`}
                            onClick={() => scrollTo(l.id)}
                            className="px-4 py-2 rounded-full text-sm font-medium text-[#1F2A23] hover:text-[#2F5F1A] hover:bg-[#F0F7E8] transition-colors"
                        >
                            {l.label}
                        </button>
                    ))}
                </nav>

                <div className="flex items-center gap-2">
                    <button
                        data-testid="header-contact-cta"
                        onClick={() => scrollTo("contact")}
                        className="hidden md:inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#1F2A23] text-white text-sm font-semibold tracking-wide hover:bg-[#2F5F1A] transition-colors"
                    >
                        無料で相談する
                    </button>
                    <button
                        data-testid="mobile-menu-toggle"
                        aria-label="メニュー"
                        onClick={() => setOpen((v) => !v)}
                        className="md:hidden inline-flex items-center justify-center w-10 h-10 rounded-full bg-white border border-[#E6EFD8] shadow-soft active:scale-95"
                    >
                        {open ? (
                            <X size={20} strokeWidth={2.5} className="text-[#2F5F1A]" />
                        ) : (
                            <Menu size={20} strokeWidth={2.5} className="text-[#2F5F1A]" />
                        )}
                    </button>
                </div>
            </div>

            {open && (
                <div
                    data-testid="mobile-menu"
                    className="md:hidden mx-5 mb-4 rounded-2xl bg-white border border-[#E6EFD8] shadow-soft p-3"
                >
                    {links.map((l) => (
                        <button
                            key={l.id}
                            data-testid={`mobile-nav-${l.id}`}
                            onClick={() => scrollTo(l.id)}
                            className="w-full text-left px-4 py-3 rounded-2xl font-bold text-[#2F5F1A] hover:bg-[#F0F7E8]"
                        >
                            {l.label}
                        </button>
                    ))}
                    <button
                        data-testid="mobile-contact-cta"
                        onClick={() => scrollTo("contact")}
                        className="w-full mt-2 px-4 py-3 rounded-full bg-[#7DB856] text-white font-bold"
                    >
                        無料で相談する
                    </button>
                </div>
            )}
        </header>
    );
}
